<template>
  <div class="options-pane">
    <div class="accordion-header">
      <!--<div class="btn-sm accordion-toggle-btn"  @click="togglePaneOpen($event)">אפשרויות ניקוד</div>-->
      <b-button class="btn-sm accordion-toggle-btn" block @click="togglePaneOpen($event)" v-bind:class="{ active: paneOpen }">
        <div>{{hebrew ? 'אפשרויות פיענוח' : 'Expansion options'}}</div>
        <!--
        <div v-if="!paneOpen"><i-caret-up></i-caret-up></div>
        <div v-else><i-caret-down></i-caret-down></div>
        -->
      </b-button>
    </div>
    <div v-if="paneOpen" class="options-pane-body">
      <div class="original-abbreviation text-right">
        <p>{{ (currentLetterNotSep && localCurrentWord.wasAnAbbreviation) ? localCurrentWord.originalWord : '\u200b' }}</p>
      </div>
      <options-list
        :pane-open="paneOpen"
        :auto-init-obj="autoInitObj"
        :options-box-styles="optionsBoxStyles"
        :local-show-aims="false"
        :allow-option-keys="!localLetterAddingMode && currentLetterNotSep"
        :options-to-show="optionsToShow"
        :relevant-options-from-user-dictionary="relevantOptionsFromUserDictionary"
        :relevant-negative-options-from-user-dictionary="relevantNegativeOptionsFromUserDictionary"
        :pinned-options-from-user-dictionary="pinnedOptionsFromUserDictionary"
        :unpinned-options-from-user-dictionary="unpinnedOptionsFromUserDictionary"
        :local-current-word-index="localCurrentWordIndex"
        :option-matcher-property="'displayText'"
        :option-matcher-value="localCurrentWord ? localCurrentWord.chosenWordString : ''"
        :option-matcher-backup="localCurrentWord ? localCurrentWord.options[localCurrentWord.chosenOptionIndex].displayText : ''"
        :option-matcher-choice-type="localCurrentWord ? localCurrentWord.choiceType : ''"
        :space-substitute="spaceSubstitute"
        @working-option-set="(shownOption) => workingShownOption = shownOption"
        @use-new-choice="useNewChoice"
        @move-to-next-word="moveToNextWord"
        @move-option-to-end="(moveToEndObj) => moveShownOptionToEnd(moveToEndObj.whichEnd, moveToEndObj.shownOption)"
        @toggle-pinned="toggleShownOptionPinned"
        @remove-from-user-dictionary="removeFromUserDictionary"
        @remove-from-user-dictionary-negatives="removeFromUserDictionaryNegatives" />
      <a id="applyToAllLink" 
        href="#"
        class="clickable-link"
        @click="showApplyToAllPopup = true">{{hebrew ? 'החל על כל הטקסט' : 'Apply to entire text'}}
      </a>
    </div>
    <b-modal v-model="showApplyToAllPopup"
             :ok-title="hebrew ? 'החל' : 'Apply'"
             :cancel-title="hebrew ? 'ביטול' : 'Cancel'"
             @ok="applyToEntireText"
             footer-class="apply-to-all-footer"
             centered
             size="sm"
    >
      <template slot="modal-header"><div>{{hebrew ? 'החל על כל הטקסט' : 'Apply to entire text'}}</div></template>
      <b-form-radio id="doBelow" value="below" v-model="applyToAllMode">{{hebrew ? 'החל אפשרות זו ממילה זו והלאה' : 'Apply for this word forward'}}</b-form-radio>
      <b-form-radio id="doUnedited" value="unedited" v-model="applyToAllMode">{{hebrew ? 'החל רק על מילים שלא נערכו' : 'Apply to all unedited words'}}</b-form-radio>
      <b-form-radio id="doAll" value="all" v-model="applyToAllMode">{{hebrew ? 'החל על כל הטקסט' : 'Apply to entire text'}}</b-form-radio>
    </b-modal>
  </div>
</template>

<script>

import OptionsList from 'shared/components/OptionsList/OptionsList'
import nikudMixins from '@/mixins/nikudMixins'
// import $ from 'jquery'
import serviceMixins from '@/mixins/serviceMixins'
import navigationMixins from '@/mixins/navigationMixins'
import wordMutatingMixins from '@/mixins/wordMutatingMixins'
import {AppConfig} from '../appConfig'
import conditionalOptions from 'shared/js/conditionalOptions'
import styleGlobals from 'shared/js/forTextPanel/styleGlobals'

export default {
  name: 'NikudOptionsPane',
  components: { OptionsList },
  mixins: [
    nikudMixins, /* for localCurrentWordIndex, localCurrentLetterIndex, localLetterAddingMode (in KeyMap),
                      currentLetterNotSep (here AND KeyMap), localCurrentWord (here AND KeyMap), 
                      modalOpen() (in keymap), showChangedNikudMessage(), 
                      removeFromUserDictionaryNegatives(), getRelevantNegativeOptionsFromUserDictionary()
                      removeFromUserDictionary (here AND KeyMap), getRelevantOptionsFromUserDictionary() */
    wordMutatingMixins, // for rewriteWordOrWordsInWorkingArrayMethod() and changeAllAlikeWordsToNewNikud()
    serviceMixins, // for gtag()
    navigationMixins // for moveToNextWord()
  ],
  props: ['subPanesStatus', 'modesObj', 'editNikudProps'],
  data () {
    return {
      autoInitObj: { command: null },
      workingShownOption: -1,
      applyToAllMode: 'below',
      showApplyToAllPopup: false
    }
  },
  computed: {
    hebrew () {
      return this.$settings.hebrew
    },
    spaceSubstitute () {
      return styleGlobals.SPACE_SUBSTITUTE
    },
    optionsBoxStyles () {
      return {
        Mobile: window.innerWidth < 992,
        Desktop: window.innerWidth >= 992,
        prefixColor: '#ba8686',
        showPaneMargin: true, // it's a "desktop" style
        smallMinHeight: false, // it's to enable showing "both panes" INCLUDING "nikud buttons"
        implementUserAccounts: true,
        offerPinning: AppConfig.OFFER_PINNING,
        nikudKeyboard: 'not-old', // it's just that if it WERE 'old' the "option keys" could not be *numbers*
        // (only needed for hotkey which now is run from PANE in nakdan) offerGenderChanging: false,
        xNegatesInBlind: AppConfig.X_NEGATES_IN_BLIND
      }
    },
    paneOpen () {
      return this.subPanesStatus.optionsOpen
    },
    relevantOptionsFromUserDictionary () {
      if (this.localCurrentWordIndex > -1) {
        const currentWordObj = this.localCurrentWord
        const wordsArray = this.$store.state.allWorkingNikud.wordsArray
        return this.getRelevantOptionsFromUserDictionary(currentWordObj)
                .map(dictString => Object.assign(conditionalOptions.optionObjFromDictString(dictString),
                  {
                    fromUserDictionary: true,
                    pinned: this.localUserDictionary.entryPresent[dictString] === 'pinned'
                  }))
                .filter(optionObj => conditionalOptions.testConditions(
                            optionObj.conditions, wordsArray, this.localCurrentWordIndex))
      } else return []
    },
    pinnedOptionsFromUserDictionary () {
      return this.relevantOptionsFromUserDictionary.filter(entry => entry.pinned)
    },
    unpinnedOptionsFromUserDictionary () {
      return this.relevantOptionsFromUserDictionary.filter(entry => !(entry.pinned))
    },
    relevantNegativeOptionsFromUserDictionary () {
      if (this.localCurrentWordIndex > -1) {
        const currentWordObj = this.localCurrentWord
        const currentWordNakdanOptions = currentWordObj.options.map(wordOpt => wordOpt.displayText)
        const wordsArray = this.$store.state.allWorkingNikud.wordsArray
        return this.getRelevantNegativeOptionsFromUserDictionary(currentWordObj)
                .map(dictString => conditionalOptions.optionObjFromDictString(dictString))
                .filter(optionObj => conditionalOptions.testConditions(
                            optionObj.conditions, wordsArray, this.localCurrentWordIndex))
                .map(o => Object.assign(o, { fromUserDictionaryNegatives: true }))
                .filter(dictOpt => currentWordNakdanOptions.includes(dictOpt.displayText))
      } else return []
    },
    optionsToShow () {
      if (this.localCurrentWordIndex > -1 && this.currentLetterNotSep) {
        var options = []
        var currentWordObj = this.localCurrentWord
        var originalOption1Index = -1
        this.pinnedOptionsFromUserDictionary.forEach(optionObj => {
          var indexInNakdanOptions = currentWordObj.options.map(o => o.displayText)
                                                           .indexOf(optionObj.displayText)
          if (indexInNakdanOptions !== -1) {
            optionObj.prefixEndIndex = currentWordObj.options[indexInNakdanOptions].prefixEndIndex
          }
          options.push(optionObj)
        })
        if (!(this.pinnedOptionsFromUserDictionary.length) // if word's pinned, no pref for nakdan's #1
            && !(this.relevantOptionsFromUserDictionary.map(o => o.displayText)
                  .concat(this.relevantNegativeOptionsFromUserDictionary.map(o => o.displayText))
                  .includes(currentWordObj.options[0].displayText))) {
          options.push(Object.assign({}, currentWordObj.options[0])) // shallow copy to change props without writing to state
          originalOption1Index = 0
        }
        this.relevantOptionsFromUserDictionary.forEach(optionObj => {
          if (!(optionObj.pinned)) {
            var indexInNakdanOptions = currentWordObj.options.map(o => o.displayText)
                                                             .indexOf(optionObj.displayText)
            if (indexInNakdanOptions !== -1) {
              optionObj.prefixEndIndex = currentWordObj.options[indexInNakdanOptions].prefixEndIndex
              optionObj.morphArray = currentWordObj.options[indexInNakdanOptions].morphArray
            }
            options.push(optionObj)
          }
        })
        currentWordObj.options.forEach((o, i) => {
          if (i !== originalOption1Index && this.relevantOptionsFromUserDictionary
                                            .concat(this.relevantNegativeOptionsFromUserDictionary)
                                            .every(optionObj => optionObj.conditions.length
                                                                || optionObj.displayText !== o.displayText)) {
            options.push(Object.assign({}, o)) // shallow copy so POSSIBLE to add props without writing to state
          }
        })
        this.relevantNegativeOptionsFromUserDictionary.slice().reverse().forEach(optionObj => {
          const e = optionObj.displayText
          if (!(this.relevantOptionsFromUserDictionary.map(o => o.displayText).includes(e))) {
            var indexInNakdanOptions = currentWordObj.options.map(o => o.displayText).indexOf(e)
            if (indexInNakdanOptions !== -1) {
              optionObj.prefixEndIndex = currentWordObj.options[indexInNakdanOptions].prefixEndIndex
            }
            options.push(optionObj)
          }
        })
        return options
      } else return []
    },
    conditionalDictStringsMatchingCurrentWord () {
      const optionLikeChosenIfAny = this.optionsToShow.map(o => o.displayText)
                                                      .indexOf(this.localCurrentWord.chosenWordString)
      const workingOptionObj = this.optionsToShow[optionLikeChosenIfAny]
      return (workingOptionObj && workingOptionObj.conditions && workingOptionObj.conditions.length)
              ? [conditionalOptions.dictStringFromOptionObj(workingOptionObj)] : []
    }
  },
  methods: {
    togglePaneOpen () {
      this.subPanesStatus.optionsOpen = !(this.subPanesStatus.optionsOpen)
    },
    useNewChoice (shownOption) {
      if (shownOption === -1) return // it shouldn't happen, but...
      if (this.optionsToShow[shownOption].fromUserDictionary) {
        if (this.optionsToShow[shownOption].displayText !== this.localCurrentWord.chosenWordString) {
          this.rewriteWordOrWordsInWorkingArrayMethod({
            contextData: { wordIndex: this.localCurrentWordIndex, letterIndex: this.localCurrentLetterIndex }, // for undo
            newWordContainer: {
              index: this.localCurrentWordIndex, changes: { 
                altered: true,
                choiceType: 'manual',
                manualNikud: this.optionsToShow[shownOption].displayText
              }
            }
          })
        }
      } else {
        var lookupIndex = this.localCurrentWord.options.map(o => o.displayText)
          .indexOf(this.optionsToShow[shownOption].displayText)
        const oldChoiceType = this.localCurrentWord.choiceType
        const oldChosenOptionIndex = this.localCurrentWord.chosenOptionIndex
        if (oldChoiceType !== 'option' || oldChosenOptionIndex !== lookupIndex) {
          this.rewriteWordOrWordsInWorkingArrayMethod({
            contextData: { wordIndex: this.localCurrentWordIndex, letterIndex: this.localCurrentLetterIndex }, // for undo
            newWordContainer: {
              index: this.localCurrentWordIndex, changes: { 
                altered: true,
                choiceType: 'option',
                chosenOptionIndex: lookupIndex
              }
            }
          })
        }
      }
    },
    applyToEntireText () {
      // (needs to have already been done! <== ) this.useNewChoice() // in case this function happens to get called first - doing it twice doesn't hurt
      var changed = this.changeAllAlikeWordsToNewNikud()
      this.showChangedNikudMessage(changed)
      document.activeElement.blur()
    },
    toggleShownOptionPinned (o) {
      const newValueOfWhetherPinned = !(this.optionsToShow[o].pinned)
      const dictString = conditionalOptions.dictStringFromOptionObj(this.optionsToShow[o])
      this.$store.commit('UPDATE_USER_DICTIONARY', {
        contextData: { wordIndex: this.localCurrentWordIndex, letterIndex: this.localCurrentLetterIndex }, // for undo
        toChangeWhetherPinned: { dictString: dictString, newValueOfWhetherPinned: newValueOfWhetherPinned }
      })
      this.showAddedToUserDictionaryMessage(newValueOfWhetherPinned ? 'pinned' : 'unpinned')
    },
    moveShownOptionToEnd (whichEnd, o) {
      const dictString = conditionalOptions.dictStringFromOptionObj(this.optionsToShow[o])
      var commitObj = {
        contextData: { wordIndex: this.localCurrentWordIndex, letterIndex: this.localCurrentLetterIndex } // for undo
      }
      const prefix = whichEnd === 'top' ? {words: 'words', entry: 'entry'} 
                                        : {words: 'negativeWords', entry: 'negativeEntry'}
      commitObj[prefix.words + 'ToAdd'] = [dictString] // the mutation always does any "delete"s BEFORE any "add"s
      if (this.localUserDictionary[prefix.entry + 'Present']
          && this.localUserDictionary[prefix.entry + 'Present'][dictString]) {
        commitObj[prefix.words + 'ToDelete'] = [dictString]
      }
      const goodOptionsLength = this.optionsToShow.length - this.relevantNegativeOptionsFromUserDictionary.length - 1
      if (whichEnd === 'bottom' && o === this.workingShownOption && this.localCurrentWord.choiceType === 'option') { // so a new workingOption ought to be "chosen"
        const newWorkingOption = goodOptionsLength > this.workingShownOption 
                                  ? this.workingShownOption + 1 // there's an option BELOW (about to "take its place")
                                  : Math.max(goodOptionsLength - 1, 0)
        this.useNewChoice(newWorkingOption)
        this.autoInitObj.command = 'init'
      }
      this.$store.commit('UPDATE_USER_DICTIONARY', commitObj)
      this.showAddedToUserDictionaryMessage(whichEnd === 'top' ? 'positive' : 'negative')
    },
  }
}
</script>

<style scoped>
.original-abbreviation {
  /* background-color: palegoldenrod; */
  margin: 0 14px;
  /* width: 50%;*/
}
.original-abbreviation p {
  font-family: Roboto, mft_narkisclassic, sans-serif;
  font-size: 20px;
  margin: 0 6px;
}
.options-pane {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.options-pane-body {
  flex: auto;
  display: flex;
  flex-direction: column;
  margin-bottom: .5rem;
  padding-top: 4px;
  height: calc(100% - 28px - .5rem); /* from App.vue: .accordion-header has height: 28px; */
}

.accordion-toggle-btn:focus{
  box-shadow: none;
  outline: none;
}
</style>
